import { LocationNumbersService } from '../../../services'

const linkPhoneNumber = async function ({ dispatch, state }, config) {
  const { locationId, companyId,payload } = config
  try {

    const data = await LocationNumbersService.linkPhoneNumber(
      companyId,
      locationId,
      payload
    )

    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchPhoneNumbers', {
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
    })
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default linkPhoneNumber
